<div class="tab-inner-content">
  <h2>Aging Report for Invoice</h2>
  <table>
    <thead>
      <tr>
        <th>Invoice No</th>
        <th>Customer Name</th>
        <th>Amount (in AED)</th>
        <th>Due Date</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="agingInvoiceReport && agingInvoiceReport.length > 0; else noData">
        <ng-container *ngFor="let item of agingInvoiceReport">
          <tr class="child">
            <td>{{ item.invoiceDetails?.invoiceNo }}</td>
            <td>{{ item?.invoiceDetails?.customerData?.firstName + ' ' + item?.invoiceDetails?.customerData?.lastName }}</td>
            <td>{{ item.invoiceDetails?.balance }}</td>
            <td>{{ item.invoiceDetails?.dueDate | date : "mediumDate" }}</td>
            <td>{{ getOverdueText(item.invoiceDetails?.dueDate) }}</td>
          </tr>
        </ng-container>
      </ng-container>
      <ng-template #noData>
        <tr>
          <td colspan="5" class="no-data">
            No data available.
          </td>
        </tr>
      </ng-template>
    </tbody>
  </table>
</div>